import { Alert } from '@material-ui/lab';
import useCallPermissionFlags from '@src/hooks/call/useCallPermissionFlags';
import { CallPermission } from '@src/types/calls';
import { FormattedMessage } from 'react-intl';

interface ContactCallPermissionsAlertProps {
  contactPermissions: CallPermission[];
}

const ContactCallPermissionsAlert: React.FC<
  ContactCallPermissionsAlertProps
> = ({ contactPermissions: permissions = [] }) => {
  const {
    isSendCallTemplateExceeded24h,
    isSendCallTemplateExceeded7d,
    isStartCallExceeded,
    isStartCallAllowed,
  } = useCallPermissionFlags(permissions);

  if (!permissions || permissions?.length === 0) return null;

  if (isSendCallTemplateExceeded24h && !isStartCallAllowed) {
    return (
      <Alert severity="info">
        <FormattedMessage id="CallPermission.SendRequest.Limit24h" />
      </Alert>
    );
  }

  if (isSendCallTemplateExceeded7d && !isStartCallAllowed) {
    return (
      <Alert severity="info">
        <FormattedMessage id="CallPermission.SendRequest.Limit7d" />
      </Alert>
    );
  }

  if (isStartCallExceeded) {
    return (
      <Alert severity="info">
        <FormattedMessage id="CallPermission.StartCall.Limit24h" />
      </Alert>
    );
  }

  return null;
};

export default ContactCallPermissionsAlert;
